import axiosInstance, { apiEndpoint } from "./api";
import TokenService from "./token.service";

import axios from "axios";

const setupInterceptors = (store) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = TokenService.getLocalAccessToken();
      if (token) {
        config.headers["Authorization"] = 'Bearer ' + token;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  axiosInstance.interceptors.response.use(
    (res) => res,
    async (err) => {
      const originalConfig = err.config;

      if (originalConfig.url !== "/auth/login" && err.response) {
        // Token expired
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;

          try {
            // Use a separate axios instance to refresh the token
            const refreshInstance = axios.create();
            const rs = await refreshInstance.post(apiEndpoint + "/api/auth/token/refresh/", {
              refresh: TokenService.getLocalRefreshToken(),
            });

            const { access } = rs.data;
            store.dispatch('auth/refreshToken', access);
            TokenService.updateLocalAccessToken(access);

            // Update authorization header and retry the request
            originalConfig.headers["Authorization"] = 'Bearer ' + access;
            return axiosInstance(originalConfig);
          } catch (_error) {
            // Refresh token failed -> Logout user
            store.dispatch('auth/logout');
            return Promise.reject(_error);
          }
        }
      }

      return Promise.reject(err);
    }
  );
};

export default setupInterceptors;
